const TEXT_COLOR_OFF = "#6c8188";
const BG_COLOR_OFF = "#c2c5c8ff";

const TEXT_COLOR_NEUTRAL = "#277692";
const BG_COLOR_NEUTRAL = "#93C9DE";

const TEXT_COLOR_1 = "#D7562C";
const BG_COLOR_1 = "#FFC6B4";

const TEXT_COLOR_2 = "#866CE4";
const BG_COLOR_2 = "#B7A7EF";

const TEXT_COLOR_3 = "#299465";
const BG_COLOR_3 = "#90CFB4";

const TEXT_COLOR_4 = "#A8781E";
const BG_COLOR_4 = "#E4BF7A";

const TEXT_COLOR_5 = "#E472B7";
const BG_COLOR_5 = "#EFAAD4";

const TEXT_COLOR_6 = "#2EA5AA";
const BG_COLOR_6 = "#81C9CC";

const TEXT_COLOR_7 = "#E26E6E";
const BG_COLOR_7 = "#EFAEAE";

const TEXT_COLOR_8 = "#60A74C";
const BG_COLOR_8 = "#B1D6A6";

const TEXT_COLOR_9 = "#7F841E";
const BG_COLOR_9 = "#D3D59E";

const TEXT_COLOR_10 = "#A746DB";
const BG_COLOR_10 = "#D3A2ED";

const TEXT_COLOR_11 = "#622EA0";
const BG_COLOR_11 = "#A56EEA";

const TEXT_COLOR_12 = "#B97625";
const BG_COLOR_12 = "#F5CA96";

const TEXT_COLOR_13 = "#8A7701";
const BG_COLOR_13 = "#D6D782";

const TEXT_COLOR_14 = "#715A85";
const BG_COLOR_14 = "#B190CF";

const TEXT_COLOR_15 = "#875467";
const BG_COLOR_15 = "#CF90A8";

const TEXT_COLOR_16 = "#4F601A";
const BG_COLOR_16 = "#A5C34A";

const TEXT_COLOR_17 = "#8A6C67";
const BG_COLOR_17 = "#DBB7B0";

const TEXT_COLOR_18 = "#A1697F";
const BG_COLOR_18 = "#F0B2CA";

const TEXT_COLOR_19 = "#8E7C4D";
const BG_COLOR_19 = "#DAC799";

const TEXT_COLOR_20 = "#8A5E62";
const BG_COLOR_20 = "#E9998A";

const TEXT_COLOR_21 = "#767CA6";
const BG_COLOR_21 = "#B6BBE5";

const TEXT_COLOR_22 = "#85713D";
const BG_COLOR_22 = "#EBD394";

const TEXT_COLOR_23 = "#905A8D";
const BG_COLOR_23 = "#CF90CB";

const TEXT_COLOR_24 = "#638C7E";
const BG_COLOR_24 = "#ACDDCC";

const TEXT_COLOR_25 = "#7269A4";
const BG_COLOR_25 = "#CBC2FC";

const TEXT_COLOR_26 = "#7C586F";
const BG_COLOR_26 = "#D4AEC6";

const TEXT_COLOR_27 = "#604976";
const BG_COLOR_27 = "#9A96C1";

const TEXT_COLOR_28 = "#134B35";
const BG_COLOR_28 = "#58917A";

const TEXT_COLOR_29 = "#5B5916";
const BG_COLOR_29 = "#ABAB43";

const TEXT_COLOR_30 = "#885E48";
const BG_COLOR_30 = "#E1B197";

const TEXT_COLOR_31 = "#5B7679";
const BG_COLOR_31 = "#9AAFB2";

const TEXT_COLOR_32 = "#9B6464";
const BG_COLOR_32 = "#ECC0C0";

const TEXT_COLOR_33 = "#845D82";
const BG_COLOR_33 = "#DBB1D8";

const TEXT_COLOR_34 = "#2B6550";
const BG_COLOR_34 = "#70C3B6";

const TEXT_COLOR_35 = "#7C9247";
const BG_COLOR_35 = "#D5EF97";

const TEXT_COLOR_36 = "#8A5075";
const BG_COLOR_36 = "#E99ECE";

const TEXT_COLOR_37 = "#77679E";
const BG_COLOR_37 = "#C9BFE1";

const TEXT_COLOR_38 = "#4A6448";
const BG_COLOR_38 = "#91B28E";

const TEXT_COLOR_39 = "#69753A";
const BG_COLOR_39 = "#B5C478";

const TEXT_COLOR_40 = "#A96C4B";
const BG_COLOR_40 = "#F4B28E";

const TEXT_COLOR_41 = "#8B793C";
const BG_COLOR_41 = "#DECF6B";

const TEXT_COLOR_42 = "#70493B";
const BG_COLOR_42 = "#BFA298";

const TEXT_COLOR_43 = "#6B3452";
const BG_COLOR_43 = "#C779A3";

const TEXT_COLOR_44 = "#537780";
const BG_COLOR_44 = "#81E8E7";

const TEXT_COLOR_45 = "#83484F";
const BG_COLOR_45 = "#F8ADB6";

const TEXT_COLOR_46 = "#3C6263";
const BG_COLOR_46 = "#80BDBF";

const TEXT_COLOR_47 = "#98679D";
const BG_COLOR_47 = "#E7CBE9";

const TEXT_COLOR_48 = "#197175";
const BG_COLOR_48 = "#43C1C6";

const TEXT_COLOR_49 = "#5D865A";
const BG_COLOR_49 = "#B7E1B4";

const TEXT_COLOR_50 = "#7E6027";
const BG_COLOR_50 = "#D2B277";

interface EventColor {
    textColor: string;
    backgroundColor: string;
    colorNumber?: number;
}

const OFFCOLOR: EventColor = {
    textColor: TEXT_COLOR_OFF,
    backgroundColor: BG_COLOR_OFF,
    colorNumber: -1,
};

const NEUTRALCOLOR: EventColor = {
    textColor: TEXT_COLOR_NEUTRAL,
    backgroundColor: BG_COLOR_NEUTRAL,
    colorNumber: 0,
};

const FIRSTCOLOR: EventColor = {
    textColor: TEXT_COLOR_1,
    backgroundColor: BG_COLOR_1,
    colorNumber: 1,
};

const LASTCOLOR: EventColor = {
    textColor: TEXT_COLOR_50,
    backgroundColor: BG_COLOR_50,
    colorNumber: 50,
};

const eventColorScheme: EventColor[] = [
    FIRSTCOLOR,
    {
        textColor: TEXT_COLOR_2,
        backgroundColor: BG_COLOR_2,
        colorNumber: 2,
    },
    {
        textColor: TEXT_COLOR_3,
        backgroundColor: BG_COLOR_3,
        colorNumber: 3,
    },
    {
        textColor: TEXT_COLOR_4,
        backgroundColor: BG_COLOR_4,
        colorNumber: 4,
    },
    {
        textColor: TEXT_COLOR_5,
        backgroundColor: BG_COLOR_5,
        colorNumber: 5,
    },
    {
        textColor: TEXT_COLOR_6,
        backgroundColor: BG_COLOR_6,
        colorNumber: 6,
    },
    {
        textColor: TEXT_COLOR_7,
        backgroundColor: BG_COLOR_7,
        colorNumber: 7,
    },
    {
        textColor: TEXT_COLOR_8,
        backgroundColor: BG_COLOR_8,
        colorNumber: 8,
    },
    {
        textColor: TEXT_COLOR_9,
        backgroundColor: BG_COLOR_9,
        colorNumber: 9,
    },
    {
        textColor: TEXT_COLOR_10,
        backgroundColor: BG_COLOR_10,
        colorNumber: 10,
    },
    {
        textColor: TEXT_COLOR_11,
        backgroundColor: BG_COLOR_11,
        colorNumber: 11,
    },
    {
        textColor: TEXT_COLOR_12,
        backgroundColor: BG_COLOR_12,
        colorNumber: 12,
    },
    {
        textColor: TEXT_COLOR_13,
        backgroundColor: BG_COLOR_13,
        colorNumber: 13,
    },
    {
        textColor: TEXT_COLOR_14,
        backgroundColor: BG_COLOR_14,
        colorNumber: 14,
    },
    {
        textColor: TEXT_COLOR_15,
        backgroundColor: BG_COLOR_15,
        colorNumber: 15,
    },
    {
        textColor: TEXT_COLOR_16,
        backgroundColor: BG_COLOR_16,
        colorNumber: 16,
    },
    {
        textColor: TEXT_COLOR_17,
        backgroundColor: BG_COLOR_17,
        colorNumber: 17,
    },
    {
        textColor: TEXT_COLOR_18,
        backgroundColor: BG_COLOR_18,
        colorNumber: 18,
    },
    {
        textColor: TEXT_COLOR_19,
        backgroundColor: BG_COLOR_19,
        colorNumber: 19,
    },
    {
        textColor: TEXT_COLOR_20,
        backgroundColor: BG_COLOR_20,
        colorNumber: 20,
    },
    {
        textColor: TEXT_COLOR_21,
        backgroundColor: BG_COLOR_21,
        colorNumber: 21,
    },
    {
        textColor: TEXT_COLOR_22,
        backgroundColor: BG_COLOR_22,
        colorNumber: 22,
    },
    {
        textColor: TEXT_COLOR_23,
        backgroundColor: BG_COLOR_23,
        colorNumber: 23,
    },
    {
        textColor: TEXT_COLOR_24,
        backgroundColor: BG_COLOR_24,
        colorNumber: 24,
    },
    {
        textColor: TEXT_COLOR_25,
        backgroundColor: BG_COLOR_25,
        colorNumber: 25,
    },
    {
        textColor: TEXT_COLOR_26,
        backgroundColor: BG_COLOR_26,
        colorNumber: 26,
    },
    {
        textColor: TEXT_COLOR_27,
        backgroundColor: BG_COLOR_27,
        colorNumber: 27,
    },
    {
        textColor: TEXT_COLOR_28,
        backgroundColor: BG_COLOR_28,
        colorNumber: 28,
    },
    {
        textColor: TEXT_COLOR_29,
        backgroundColor: BG_COLOR_29,
        colorNumber: 29,
    },
    {
        textColor: TEXT_COLOR_30,
        backgroundColor: BG_COLOR_30,
        colorNumber: 30,
    },
    {
        textColor: TEXT_COLOR_31,
        backgroundColor: BG_COLOR_31,
        colorNumber: 31,
    },
    {
        textColor: TEXT_COLOR_32,
        backgroundColor: BG_COLOR_32,
        colorNumber: 32,
    },
    {
        textColor: TEXT_COLOR_33,
        backgroundColor: BG_COLOR_33,
        colorNumber: 33,
    },
    {
        textColor: TEXT_COLOR_34,
        backgroundColor: BG_COLOR_34,
        colorNumber: 34,
    },
    {
        textColor: TEXT_COLOR_35,
        backgroundColor: BG_COLOR_35,
        colorNumber: 35,
    },
    {
        textColor: TEXT_COLOR_36,
        backgroundColor: BG_COLOR_36,
        colorNumber: 36,
    },
    {
        textColor: TEXT_COLOR_37,
        backgroundColor: BG_COLOR_37,
        colorNumber: 37,
    },
    {
        textColor: TEXT_COLOR_38,
        backgroundColor: BG_COLOR_38,
        colorNumber: 38,
    },
    {
        textColor: TEXT_COLOR_39,
        backgroundColor: BG_COLOR_39,
        colorNumber: 39,
    },
    {
        textColor: TEXT_COLOR_40,
        backgroundColor: BG_COLOR_40,
        colorNumber: 40,
    },
    {
        textColor: TEXT_COLOR_41,
        backgroundColor: BG_COLOR_41,
        colorNumber: 41,
    },
    {
        textColor: TEXT_COLOR_42,
        backgroundColor: BG_COLOR_42,
        colorNumber: 42,
    },
    {
        textColor: TEXT_COLOR_43,
        backgroundColor: BG_COLOR_43,
        colorNumber: 43,
    },
    {
        textColor: TEXT_COLOR_44,
        backgroundColor: BG_COLOR_44,
        colorNumber: 44,
    },
    {
        textColor: TEXT_COLOR_45,
        backgroundColor: BG_COLOR_45,
        colorNumber: 45,
    },
    {
        textColor: TEXT_COLOR_46,
        backgroundColor: BG_COLOR_46,
        colorNumber: 46,
    },
    {
        textColor: TEXT_COLOR_47,
        backgroundColor: BG_COLOR_47,
        colorNumber: 47,
    },
    {
        textColor: TEXT_COLOR_48,
        backgroundColor: BG_COLOR_48,
        colorNumber: 48,
    },
    {
        textColor: TEXT_COLOR_49,
        backgroundColor: BG_COLOR_49,
        colorNumber: 49,
    },
    LASTCOLOR,
];

/** Hämtar färg baserat på id. ID:n större än palettens längd lindar om via modulo (id 51 → färg 1, id 100 → färg 50). */
const getEventColor = (id: number): Omit<EventColor, "colorNumber"> => {
    if (id === -1) {
        return OFFCOLOR;
    } else if (!id) {
        return NEUTRALCOLOR;
    }

    return eventColorScheme[(id - 1) % eventColorScheme.length];
};

export {
    FIRSTCOLOR,
    LASTCOLOR,
    eventColorScheme,
    NEUTRALCOLOR,
    OFFCOLOR,
    getEventColor,
    BG_COLOR_NEUTRAL,
    TEXT_COLOR_NEUTRAL,
};
